module.exports = __webpack_public_path__ + "img/aircraft_box1.3f51512f.png";